export default __webpack_public_path__ + "static/media/four.9dac5cae.jpg";